// components/CaseView/FilesTable.tsx
import React from "react";

import {
  StyledTable,
  TBody,
  Td,
  Th,
  THead,
  Tr,
} from "../../shared/TableComponents";
import { DeleteIconButton } from "../../shared/helpers/GlobalStylesv5";
import { EmptyState } from "../../shared/helpers/StatePrimitives";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import { tokens } from "../../../theme/tokens";

const FileTypeIcon = ({ type }: { type: string }) => {
  const sx = { fontSize: "18px", color: tokens.color.text.secondary, flex: "0 0 auto" };
  if (type === "doc") return <PictureAsPdfOutlinedIcon sx={sx} />;
  if (type === "img") return <ImageOutlinedIcon sx={sx} />;
  return <InsertDriveFileOutlinedIcon sx={sx} />;
};

interface FilesTableProps {
  files: any[];
  onFileClick: (e: React.MouseEvent, file: any) => void;
  onDeleteClick: (file: any) => void;
}

const FilesTable: React.FC<FilesTableProps> = ({
  files,
  onFileClick,
  onDeleteClick,
}) => {
  const visible = files?.filter((file) => file.type !== "video") ?? [];

  if (visible.length === 0) {
    return (
      <div style={{ width: "96%", margin: "0 auto" }}>
        <EmptyState
          icon={<InsertDriveFileOutlinedIcon />}
          title="No documents yet"
          description="Upload files above and they will appear here."
        />
      </div>
    );
  }

  return (
    <div style={{ width: "96%", margin: "0 auto" }}>
      <StyledTable>
        <THead>
          <Tr>
            <Th>Case Name</Th>
            <Th>Date uploaded</Th>
            <Th>Options</Th>
          </Tr>
        </THead>
        <TBody>
          {visible.map((file, index) => (
              <Tr key={file.key || index} onClick={(e) => onFileClick(e, file)}>
                <Td
                  style={{
                    cursor: "pointer",
                    minWidth: "220px",
                  }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <FileTypeIcon type={file.type} />
                    <span
                      style={{
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {file.name}
                    </span>
                  </span>
                </Td>
                <Td>{file.dateCreated}</Td>
                <Td
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <DeleteIconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      onDeleteClick(file);
                    }}
                    tooltipTitle={`Delete ${file.name}`}
                  />
                </Td>
              </Tr>
            ))}
        </TBody>
      </StyledTable>
    </div>
  );
};

export default FilesTable;
